/**
 * ConfirmDialog — small confirmation popup.
 *
 * Usage:
 *   <ConfirmDialog
 *     message="Deactivate John Doe?"
 *     onConfirm={() => doDelete()}
 *     onCancel={() => setConfirm(null)}
 *     danger
 *   />
 */
import React from 'react';

export default function ConfirmDialog({ message, detail, onConfirm, onCancel, danger = true, confirmLabel = 'Confirm', loading = false }) {
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100,
      }}
    >
      <div style={{
        background: '#fff', borderRadius: 12, padding: 28, maxWidth: 400, width: '100%',
        margin: '0 16px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }}>
        <div style={{ fontSize: 30, marginBottom: 12, textAlign: 'center' }}>
          {danger ? '⚠️' : 'ℹ️'}
        </div>
        <p style={{ margin: '0 0 8px', fontSize: 15, fontWeight: 600, color: '#2b1b22', textAlign: 'center' }}>
          {message}
        </p>
        {detail && (
          <p style={{ margin: '0 0 20px', fontSize: 13, color: '#8b7681', textAlign: 'center' }}>{detail}</p>
        )}
        {!detail && <div style={{ marginBottom: 20 }} />}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{ padding: '9px 22px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: '9px 22px',
              background: danger ? '#ef4444' : '#94335a',
              color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Processing…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
